import {
  MainButton,
  MainLink,
  Subtitle,
  Title,
} from '../../styles/GlobalStyledComponents';
import ImageSrc from '../../assets/images/timeout/timeoutImg.svg';
import { TimeoutImage } from './TimeoutStyledComponents';
import PostMessageService from '../../services/PostMessage';
import { useEffect, useState } from 'react';
import ViewModeService from '../../services/ViewMode';
import { useMerchant } from '../../contexts/MerchantContext';
import { useCreditProposalResult } from '../../contexts/CreditProposalResultContext';

interface TimeoutProps {
  loadingEvent: (data: boolean) => void;
}

export const Timeout: React.FC<TimeoutProps> = ({ loadingEvent }) => {
  const { creditProposalResult } = useCreditProposalResult();
  const { isPostDataMessages } = useMerchant();

  const [isApp, setisApp] = useState<boolean>(false);
  const [device, setDevice] = useState<string | null>(null);

  const handleCancel = async () => {
    if (isApp && device === 'android') {
      window.location.href = 'peppermerchants://home';
    } else {
      PostMessageService.closeCEX();
    }
  }

  useEffect(() => {
    if (isPostDataMessages) {
      PostMessageService.FinancingFailed(
        creditProposalResult?.credit_proposal_id
      );
    }
  }, []);

  useEffect(() => {
    loadingEvent(false);
  }, [loadingEvent]);

  useEffect(() => {
    setisApp(ViewModeService.getViewMode() === 'APP' ? true : false);
    setDevice(ViewModeService.getDevice());
  }, [isApp, device]);

  return (
    <>
      <Title id="timeout-title">Tu sesión ha caducado</Title>
      <Subtitle>Vuelve a intentarlo nuevamente</Subtitle>
      <TimeoutImage src={ImageSrc} />
      {isApp && device === 'ios' ? (
        <MainLink href="peppermerchants://home">Aceptar</MainLink>
      ) : (
        <MainButton id="timeout-accept-button" onClick={handleCancel}>
          Aceptar
        </MainButton>
      )}
    </>
  );
};
